<template>
  <transition name="fade"  appear>
    <keep-alive :include="CachedComponents">
      <router-view :key="$route.path" />
    </keep-alive>
  </transition>
</template>

<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      //keep-alive缓存的组件
      CachedComponents: [],
    }
  },
  components: {
  },
  created() {
    // 设置路由后置守卫，动态管理keep-alive缓存
    this.$router.afterEach((to, from) => {
      console.log('路由后置守卫 - 从', from.name, '到', to.name, to.meta);
      // 如果目标路由需要缓存且还未添加到缓存列表中
      if (to.meta && to.meta.keepAlive && to.name) {
        if (!this.CachedComponents.includes(to.name)) {
          this.CachedComponents.push(to.name);
          console.log('路由后置守卫 - 添加到缓存:', to.name, this.CachedComponents);
        }
      }

    });
  },
  methods: {
    reload() {
      this.CachedComponents = []; // 删除所有缓存
      // this.isRouterAlive = false;
      // this.$nextTick(() => {
      //   this.isRouterAlive = true;
      //   // 缓存会通过路由前置守卫重新动态添加，无需手动设置
      // });
    }
  }

}
</script>

<style>
/* 淡入淡出动画 - Vue 2 语法 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

/* Vue2 过渡初始/结束状态类名应为 .fade-enter / .fade-leave-to */
.fade-enter,
.fade-leave-to {
  opacity: 0.3;
}

/* .van-picker__frame {
  border: .0625rem solid black;
} */

* {
  user-select: none;
}

div {
  -webkit-user-select: text;
  user-select: text;
  height: auto;
}

div * {
  -webkit-user-select: text;
  user-select: text;
}
</style>
